import React, { forwardRef } from "react";

// Off-screen branded card that gets rasterized to a shareable PNG.
// Rendered hidden (fixed, far off-screen) whenever a reading exists.
export const ShareCard = forwardRef(
  ({ deckName, spreadName, cards = [], interpretation = "" }, ref) => {
    const text =
      interpretation.length > 640
        ? `${interpretation.slice(0, 620).trim()}…`
        : interpretation;

    return (
      <div
        ref={ref}
        style={{
          position: "fixed",
          left: -99999,
          top: 0,
          width: 1080,
          padding: "72px 64px",
          background:
            "radial-gradient(circle at 50% 0%, #1a1530 0%, #0B0C15 60%)",
          color: "#F8F3E6",
          fontFamily: "'Outfit', system-ui, sans-serif",
          boxSizing: "border-box",
        }}
      >
        {/* Brand */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div
            style={{
              fontSize: 22,
              letterSpacing: 8,
              textTransform: "uppercase",
              color: "#D9A441",
            }}
          >
            The Cardlight
          </div>
          <div style={{ marginTop: 10, fontSize: 18, color: "#A3A5B8" }}>
            {deckName} · {spreadName}
          </div>
        </div>

        {/* Cards */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 24,
            marginBottom: 44,
          }}
        >
          {cards.map((c, i) => {
            const card = c.card || c;
            return (
              <div key={i} style={{ width: 172, textAlign: "center" }}>
                <div
                  style={{
                    width: 172,
                    height: 275,
                    borderRadius: 14,
                    overflow: "hidden",
                    border: "2px solid rgba(217,164,65,0.55)",
                    background: "#131422",
                  }}
                >
                  {card.image && (
                    <img
                      src={card.image}
                      alt={card.title || card.name}
                      crossOrigin="anonymous"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transform:
                          c.reversed && spreadName !== "Oracle"
                            ? "rotate(180deg)"
                            : "none",
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    marginTop: 12,
                    fontSize: 17,
                    fontWeight: 600,
                    lineHeight: 1.2,
                  }}
                >
                  {card.title || card.name}
                </div>
                {c.reversed && (
                  <div style={{ marginTop: 4, fontSize: 12, color: "#C98089" }}>
                    Reversed
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Interpretation */}
        <div
          style={{
            borderTop: "1px solid rgba(217,164,65,0.25)",
            paddingTop: 32,
            fontSize: 24,
            lineHeight: 1.65,
            color: "#D7D3C6",
            textAlign: "center",
          }}
        >
          {text}
        </div>

        <div
          style={{
            marginTop: 44,
            textAlign: "center",
            fontSize: 16,
            letterSpacing: 3,
            textTransform: "uppercase",
            color: "#8A8CA0",
          }}
        >
          ✦ A quiet moment of insight ✦
        </div>
      </div>
    );
  }
);

ShareCard.displayName = "ShareCard";
